import React from "react";

function WorkshopSearch({ value, onChange }) {
  return (
    <aside className="package-widget widget-search">
      <div className="widget-title"><h4>Search for workshops</h4></div>
      <div className="widget-body">
        <input
          className="form-control"
          type="search"
          placeholder="Keyword in title or tutor"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </aside>
  );
}
export default WorkshopSearch;
